import {Button, ColourSolid, FlexGap, StackHorizontal} from "@twigsby/frontend-framework";
import React, {useEffect, useState} from "react";

type MailTypeConditionType = {
    name: string;
    defaultValue: any;
    changeCallback: (value: any) => void;
}

const MailTypeCondition = (props: MailTypeConditionType) => {
    const [ mailType, setMailType ] = useState<number>(props.defaultValue || -1);

    useEffect(() => {
        if(mailType !== props.defaultValue) {
            props.changeCallback(mailType);
        }
    }, [mailType]);

    useEffect(() => {
        if(props.defaultValue !== undefined && props.defaultValue !== mailType) {
            setMailType(props.defaultValue);
        }
    }, [props.defaultValue]);

    return (
        <StackHorizontal gap={FlexGap.Small}>
            <Button title={`Any`} squared={true} fullWidth={true} onClick={() => setMailType(0)} colour={mailType === 0 ? ColourSolid.Selected : ColourSolid.Secondary } />
            <Button title={'Letter'} squared={true} fullWidth={true} onClick={() => setMailType(1)} colour={mailType === 1 ? ColourSolid.Selected : ColourSolid.Secondary } />
            <Button title={`Parcel`} squared={true} fullWidth={true} onClick={() => setMailType(2)} colour={mailType === 2 ? ColourSolid.Selected : ColourSolid.Secondary } />
        </StackHorizontal>
    )
}

export { MailTypeCondition }
